<template>
  <div class="q-and-a-detail" :class="{ 'padding-for-download': !isInProject }">
    <scroller
      v-if="!onError"
      class="qa-detail-scroller"
      :class="{ 'no-answer': answers.data && answers.data.length === 0 }"
      ref="scroller"
      :on-infinite="onInfinite"
      :scrollingComplete="scrollingComplete"
      :on-refresh="onRefresh"
      refresh-text="刷新"
      no-data-text="没有更多了哦"
    >
      <!-- 标题和标签 -->
      <div class="title-and-tag">
        <div class="title" ref="qaTitle" v-text="question.question"></div>
        <div
          class="desc"
          @click="question.clickedShowMore = true"
          v-if="question.description"
        >
          <span
            v-text="
              question.clickedShowMore
                ? question.description
                : getMaxDisplayContent(question.description, maxDescLetterCount)
            "
            class="content"
            :class="{
              'margin-for-show-more':
                question.description.length > maxDescLetterCount,
            }"
          ></span>
          <span
            class="show-all-content"
            v-if="question.needShowMoreDesc && !question.clickedShowMore"
            >展开全部<img src="../../static/img/open-all.png"
          /></span>
        </div>
        <ul
          class="tags"
          :class="{
            'for-none-tag':
              !question.label ||
              (question.label && question.label.length === 0),
          }"
        >
          <li
            v-for="(label, index) in question.label"
            :key="index"
            v-text="label"
          ></li>
        </ul>
      </div>

      <!-- 国家 -->
      <div
        class="national"
        v-if="question.visa_country_id"
        @click="goToNationDetailInApp"
      >
        <img :src="question.national_flag_img" class="flag" />
        <div class="title" v-text="question.country"></div>
        <img
          class="more"
          v-if="params.is_in_app"
          src="../../static/img/more@2x.png"
        />
      </div>

      <!-- 回答列表 -->
      <div class="answer-list">
        <div class="answer-list-title" v-if="answers.totalCount">
          全部回答（{{ answers.totalCount }}）
        </div>

        <!-- 有回答 -->
        <div class="answers" v-if="answers.data && answers.data.length">
          <div class="answer" v-for="answer in answers.data" :key="answer.id">
            <div class="head">
              <img class="avartar" :src="answer.avatar" />
              <div class="name" v-text="answer.nickname"></div>
              <img
                class="official"
                v-if="answer.official"
                src="../../static/img/official@2x.png"
              />
              <div class="fill-space"></div>
              <div
                class="option"
                v-if="isInProject"
                @click="clickAnswerOption(answer)"
              >
                <img src="../../static/img/option.png" />
              </div>
            </div>

            <!-- 回答内容 -->
            <p
              class="content"
              @click="answer.clickedShowMore = !answer.clickedShowMore"
            >
              <span
                v-text="
                  answer.clickedShowMore
                    ? answer.answer
                    : getMaxDisplayContent(answer.answer, maxAnswerLetterCount)
                "
                class="answer-text"
                :class="{ 'margin-for-show-more': answer.needShowMoreAnswer }"
              ></span>
              <span
                class="show-all-content"
                v-if="answer.needShowMoreAnswer"
                :class="{ 'clicked-show-more': answer.clickedShowMore }"
                >{{ !answer.clickedShowMore ? '展开全部' : '收起'
                }}<img src="../../static/img/open-all.png"
              /></span>
            </p>

            <!-- 底部 -->
            <div class="bottom">
              <div
                class="date"
                v-text="getAnswerUpdateDate(answer.update_time)"
              ></div>
              <div class="fill-space"></div>

              <!-- 在app中才可以点赞 -->
              <div
                v-if="isInProject"
                class="like-box"
                @click="likeOrNot(answer)"
              >
                <img
                  class="like"
                  v-if="!answer.liked"
                  src="../../static/img/like.png"
                />
                <img class="liked" v-else src="../../static/img/liked.png" />
                <div
                  class="liked-count"
                  v-if="answer.like_count"
                  v-text="answer.like_count"
                ></div>
                <div class="liked-count" v-else>赞</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 没有回答 -->
        <div class="none-answer" v-else>
          <img src="../../static/img/none-answer.png" />
          <div class="desc">
            <div>暂时还没人回答，</div>
            <div>来做第一个回答的人吧！</div>
          </div>
        </div>
      </div>
    </scroller>

    <!-- 下载app -->
    <app-downLoad :channel="channel" v-if="!isInProject" class="bottom-0" />

    <!-- 底部操作 -->
    <div
      class="bottom-bar"
      :class="{ 'cant-share': !params.can_share }"
      v-if="isInProject && !onError"
    >
      <div class="share" v-if="params.can_share" @click="shareQuestion()">
        <img src="../../static/img/share.png" />
        <div>分享</div>
      </div>
      <div class="follow-box" @click="questioWatch(question)">
        <img v-if="!question.watched" src="../../static/img/follow.png" />
        <img v-else src="../../static/img/followed.png" />
        <div v-if="!question.watch_count">关注</div>
        <div v-else v-text="question.watch_count"></div>
      </div>
      <div class="reply" @click="replyQuestion(question)">我来回答</div>
    </div>

    <!-- 出错了 -->
    <div class="on-errror" v-if="onError">
      <img src="../../static/img/empty.png" />
      <div class="desc">Oops~您访问的页面可能已被删除</div>
    </div>

    <!-- 删除或者举报 -->
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>

    <!-- 举报内容 -->
    <mt-popup v-model="popupVisible" position="bottom" class="report-pop-up">
      <div class="pop-title">
        <div @click="popupVisible = false" class="close">
          <img src="../../static/img/close@2x.png" />
        </div>
        <div>举报类型</div>
      </div>
      <div class="pop-content">
        <scroller :scrollingComplete="scrollingCompleteT">
          <div class="reasons">
            <div
              class="report-item"
              v-for="reason in reportReasonsArr"
              :key="reason.value"
            >
              <label>
                <input
                  type="checkbox"
                  name="report"
                  v-model="selectedReportReasons"
                  :value="reason.value"
                />
                <span>{{ reason.label }}</span>
              </label>
            </div>
          </div>
        </scroller>
      </div>
      <div class="pop-foot">
        <button
          class="report"
          :disabled="selectedReportReasons.length === 0"
          @click="reportAnswer"
        >
          提交
        </button>
      </div>
    </mt-popup>

    <div
      class="wxa-share-popup"
      v-if="showWxaSharePopup"
      @click="showWxaSharePopup = false"
    >
      <div class="tips"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { MessageBox } from 'mint-ui';
import appDownLoad from '../components/appDownLoad';
import utils from '../services/tools.js';
import dev from '../services/dev';
import qaService from '../services/qaService.js';
import toast from '../services/toast';

export default {
  name: 'q-and-a-detial',
  components: {
    appDownLoad,
  },
  data() {
    return {
      channel: '6jj6u8io',
      urlPrefix: `https://${dev}api.11visa.com/h5`,
      maxDescLetterCount: 65,
      maxAnswerLetterCount: 105,
      question: {},
      answers: {
        totalCount: 0,
        data: [],
        page: 1,
      },
      params: {
        id: 0,
        user_account_id: 0,
        is_in_app: 0,
        visa_country_id: 0,
        can_share: 0,
        is_in_h5: 0,
        is_in_wxa: 0,
      },
      isUserLogined: true,
      sheetVisible: false,
      actions: [],
      popupVisible: false,
      fisrTimeLoadedAfterQuestionQuery: false,
      currentHandleAnswer: {},
      reportReasons: [],
      selectedReportReasons: [],
      reportReasonsArr: [],
      onError: false,
      showWxaSharePopup: false,
    };
  },
  methods: {
    // 是否在项目中
    isInProject() {
      return this.params.is_in_app || this.params.is_in_h5;
    },
    // 去掉时间
    getAnswerUpdateDate(updateTime) {
      return moment(updateTime).format('YYYY-MM-DD');
    },

    // 这个是让下面的scroller不报错
    scrollingCompleteT() {},

    // 删除答案
    deleteAnswer() {
      MessageBox({
        title: '',
        message: '确定要删除该答案吗？',
        showCancelButton: true,
        confirmButtonText: '删除',
        cancelButtonText: '再想想',
        confirmButtonClass: 'red-delete-btn',
      }).then((action) => {
        if (action === 'confirm') {
          qaService.qaAnswerDelete(this.currentHandleAnswer.id).then((data) => {
            if (data.body.ret === -1) {
              toast.show(data.body.msg);
              if (data.body.msg === '答案可能被删除') {
                this.getQAData();
              }
            } else {
              this.answers.data = this.answers.data.filter(
                (answer) => answer.id !== this.currentHandleAnswer.id,
              );
              this.question.answered = 0;
              this.answers.totalCount -= 1;
              toast.show('删除成功~');
              utils.getBridge((bridge) => {
                bridge.callHandler(
                  'delete_answer',
                  { id: this.currentHandleAnswer.id },
                  () => {},
                );
              });
            }
          });
        }
      });
    },

    // 打开举报答案对话框
    openReportAnswerPopup() {
      this.selectedReportReasons = [];
      if (this.reportReasons.length !== 0) {
        this.sheetVisible = false;
        this.popupVisible = true;
      } else {
        qaService.qaAnswerReportReasonQuery().then((data) => {
          this.reportReasons = data.body.body;
          this.reportReasonsArr = this.reportReasons.map((reason) => ({
            label: reason.reason,
            value: reason.id,
          }));
          this.sheetVisible = false;
          this.popupVisible = true;
        });
      }
    },

    // 举报答案
    reportAnswer() {
      qaService
        .qaAnswerReport(
          this.currentHandleAnswer.id,
          this.selectedReportReasons,
          this.params.user_account_id,
        )
        .then((data) => {
          if (data.body.ret === 0) {
            this.popupVisible = false;
            toast.show('已成功举报~');
          } else {
            this.popupVisible = false;
            toast.show(data.body.msg ? data.body.msg : '你已举报过该答案啦~');
            this.getQAData();
          }
        })
        .catch(() => {
          toast.show('提交失败，请再试试~');
        });
    },

    // 点击回答上面的三个点
    clickAnswerOption(answer) {
      // 暂存一下
      this.currentHandleAnswer = answer;
      this.userLoginWithCallBack(() => {
        // 判断当前用户是不是回答者，如果是就是删除，否则就是举报
        if (this.params.user_account_id === answer.user_account_id) {
          this.actions = [
            {
              name: '删除',
              method: this.deleteAnswer,
            },
          ];
        } else {
          this.actions = [
            {
              name: '举报',
              method: this.openReportAnswerPopup,
            },
          ];
        }
        this.sheetVisible = true;
      });
    },

    // 判断用户登陆，如果没有登陆，就发起登陆，如果登陆了，就处理回调
    userLoginWithCallBack(callback) {
      if (this.isUserLogined) {
        callback.call(this);
        return;
      }
      if (this.params.is_in_app) {
        this.letUserLogin();
      } else if (this.params.is_in_h5) {
        //
        window.parent.postMessage(
          {
            type: 'user_login',
          },
          '*',
        );
      } else if (this.params.is_in_wxa) {
        // 微信小程序
        wx.miniProgram.navigateTo({ url: '/pages/login/login/login' });
      }
    },

    // 获取最大展示长度的字符串
    getMaxDisplayContent(str, count) {
      if (str && str.length > count) {
        return `${str.substring(0, count)}...`;
      }
      return str;
    },

    // 滚动完成之后，告知app一个事件，下面的15是.title-and-tag的padding值
    scrollingComplete() {
      if (this.params.is_in_app) {
        const isScrollOverTitle =
          this.$refs.scroller.getPosition().top >
          this.$refs.qaTitle.clientHeight + 15;
        const title = isScrollOverTitle ? this.question.question : '问题详情';
        utils.getBridge((bridge) => {
          bridge.callHandler('scroll_over_title', { title }, () => {});
        });
      }
    },

    // 关注或者取消关注
    questioWatch(question) {
      MtaH5.clickStat('questiondetail_favorite');
      this.userLoginWithCallBack(() => {
        const params = {
          qa_question_id: this.question.id,
          visa_country_id: this.question.visa_country_id
            ? this.question.visa_country_id
            : this.params.visa_country_id
            ? this.params.visa_country_id
            : undefined,
          user_account_id: this.params.user_account_id,
          watch: question.watched ? 0 : 1,
        };
        qaService.qaQuestionWatch(params).then((data) => {
          if (data.body.ret !== -1) {
            const realData = data.body.body;
            question.watched = !question.watched;
            question.watch_count = realData.watch_count;
            toast.show(question.watched ? '已关注' : '已取消');
            utils.getBridge((bridge) => {
              bridge.callHandler(
                'watch',
                { count: realData.watch_count },
                () => {},
              );
            });
          } else {
            toast.show(data.body.msg);
            if (data.body.msg === '问题不存在') {
              this.getQAData();
            }
          }
        });
      });
    },

    // 分享问题
    shareQuestion() {
      MtaH5.clickStat('questiondetail_sharequestion');
      if (this.params.is_in_app) {
        qaService.getQADetail(this.params).then((response) => {
          const questionData = response.body.body;
          if (questionData) {
            utils.getBridge((bridge) => {
              let content = '熊猫签证，足不出户办签证';
              if (this.answers.data && this.answers.data.length > 0) {
                content = this.answers.data[0].answer;
              }

              const newParams = {
                title: `熊猫签证-${this.question.question}`,
                content,
                image: `https://${dev}h5.11visa.com/static/img/panda@2x.png`,
                url: `https://${dev}h5.11visa.com/#/qAndADetial?id=${this.params.id}`,
              };

              if (this.params.visa_country_id) {
                newParams.url = `${newParams.url}&visa_country_id=${this.params.visa_country_id}`;
              }

              bridge.callHandler('client_share', newParams, () => {});
            });
          } else {
            this.getQAData();
          }
        });
      } else if (this.params.is_in_wxa) {
        this.showWxaSharePopup = true;
      }
    },

    // 回答问题
    replyQuestion(question) {
      this.userLoginWithCallBack(() => {
        qaService.getQADetail(this.params).then((response) => {
          const questionData = response.body.body;
          if (questionData) {
            this.question.answered = questionData.answered;
            if (this.params.is_in_app) {
              utils.getBridge((bridge) => {
                bridge.callHandler('reply_question', { question }, () => {});
              });
            } else if (this.params.is_in_h5) {
              if (question.answered) {
                toast.show('您已回答过该问题');
                return;
              }
              window.parent.postMessage(
                {
                  type: 'reply_question',
                  data: {
                    question,
                  },
                },
                '*',
              );
            } else if (this.params.is_in_wxa) {
              if (question.answered) {
                toast.show('您已回答过该问题');
                return;
              }
              // 微信小程序
              wx.miniProgram.navigateTo({
                url: `/pages/visa/qa-reply/qa-reply?visa_country_id=${
                  this.params.visa_country_id
                }&question=${encodeURIComponent(JSON.stringify(question))}`,
              });
            }
          } else {
            this.getQAData();
          }
        });
      });
    },

    // 点赞或者取消点赞
    likeOrNot(answer) {
      this.userLoginWithCallBack(() => {
        const params = {
          qa_answer_id: answer.id,
          user_account_id: this.params.user_account_id,
          like: answer.liked ? 0 : 1,
        };
        qaService.qaAnswerLike(params).then((data) => {
          if (data.body.ret !== -1) {
            const realData = data.body.body;
            answer.liked = !answer.liked;
            answer.like_count = realData.like_count;
            utils.getBridge((bridge) => {
              bridge.callHandler(
                'like',
                { id: answer.id, count: realData.like_count },
                () => {},
              );
            });
          } else {
            toast.show(data.body.msg);
            if (data.body.msg === '答案可能被删除') {
              this.getQAData();
            }
          }
        });
      });
    },

    // 让用户去登陆
    letUserLogin() {
      if (this.params.is_in_app && !this.isUserLogined) {
        utils.getBridge((bridge) => {
          bridge.callHandler('go_to_login', {}, () => {});
        });
      }
    },

    // 上拉更多
    onInfinite(done) {
      // 这里故意做一个开关，因为这个方法进入页面就会疯狂的调用，但是必须要等到monuted中第一次调用完成之后
      // 上拉更多
      if (this.fisrTimeLoadedAfterQuestionQuery) {
        // 因为进来的时候要加载一次，所以这样处理
        if (this.answers.data && this.answers.data.length > 0) {
          if (this.answers.totalCount > 0) {
            // 上面都大于0了，这里肯定要+1
            const totalPage = this.answers.totalCount / 20 + 1;

            if (this.answers.page < totalPage) {
              // 下一页
              this.answers.page += 1;

              qaService
                .getQAAnswer(
                  this.question.id,
                  this.params.user_account_id,
                  this.answers.page,
                )
                .then((data) => {
                  const realData = data.body.body;
                  const newPageData = realData.qa_answer.map((answer) => {
                    const newAnswer = Object.assign({}, answer);
                    newAnswer.needShowMoreAnswer =
                      newAnswer.answer.length > this.maxAnswerLetterCount;
                    newAnswer.clickedShowMore = false;
                    return newAnswer;
                  });
                  this.answers.totalCount = realData.total_count;
                  this.answers.data = [...this.answers.data, ...newPageData];

                  const newTotalPage = this.answers.totalCount / 20 + 1;
                  if (this.answers.page === newTotalPage) {
                    done(true);
                  } else {
                    done();
                  }
                });
            } else {
              done(true);
            }
          } else {
            done(true);
          }
        } else {
          done(true);
        }
      } else {
        done(true);
      }
    },

    /**
     * 获取参数
     */
    getParams() {
      if (location.href.indexOf('id') > -1) {
        this.params.id = +utils.getParamByName('id');
      }
      if (location.href.indexOf('user_account_id') > -1) {
        this.params.user_account_id = +utils.getParamByName('user_account_id');
      }
      if (location.href.indexOf('visa_country_id') > -1) {
        this.params.visa_country_id = +utils.getParamByName('visa_country_id');
      }
      if (location.href.indexOf('is_in_app') > -1) {
        this.params.is_in_app = +utils.getParamByName('is_in_app');
      }
      if (location.href.indexOf('can_share') > -1) {
        this.params.can_share = +utils.getParamByName('can_share');
      }
      if (location.href.indexOf('is_in_h5') > -1) {
        this.params.is_in_h5 = +utils.getParamByName('is_in_h5');
      }
      if (location.href.indexOf('is_in_wxa') > -1) {
        this.params.is_in_wxa = +utils.getParamByName('is_in_wxa');
      }
    },

    // 跳转到国家详情
    goToNationDetailInApp() {
      if (this.params.is_in_app) {
        utils.getBridge((bridge) => {
          bridge.callHandler(
            'country_page',
            { visa_country_id: this.question.visa_country_id },
            () => {},
          );
        });
      }
    },

    // 获取用户登陆的状态
    setUserLoginStatus() {
      if (this.params.is_in_app) {
        utils.getBridge((bridge) => {
          bridge.callHandler('is_user_login', {}, (data) => {
            const authData = typeof data === 'string' ? JSON.parse(data) : data;
            this.isUserLogined = authData.is_user_login;
          });
        });
      } else {
        // 其他端，直接判断user_account_id是否存在
        this.isUserLogined = Boolean(this.params.user_account_id);
      }
    },

    // 问题是否删除
    isQuestionDeleted(deleted) {
      if (this.params.is_in_app) {
        utils.getBridge((bridge) => {
          bridge.callHandler('is_question_deleted', { deleted }, () => {});
        });
      }
    },

    // 获取问题数据
    getQAData() {
      this.onError = false;
      qaService
        .getQADetail(this.params)
        .then((response) => {
          const questionData = response.body.body;

          // 用一个变量来预先存好是否需要展示描述的“展示全部”
          questionData.needShowMoreDesc =
            questionData.description.length > this.maxDescLetterCount;

          // 是否点击过展示更多
          questionData.clickedShowMore = false;
          this.question = questionData;
          if (this.params.is_in_wxa) {
            wx.miniProgram.postMessage({
              data: {
                type: 'question-detail',
                detail: questionData,
              },
            });
          }
          this.getAnswerData();
          this.isQuestionDeleted(false);
        })
        .catch(() => {
          this.onError = true;
          this.isQuestionDeleted(true);
        });
    },

    // 下拉刷新
    onRefresh(done) {
      this.answers.page = 1;
      this.getAnswerData(done);
    },

    // 获取详情数据
    getAnswerData(done) {
      if (!this.question || !this.question.id) return;
      qaService
        .getQAAnswer(
          this.question.id,
          this.params.user_account_id,
          this.answers.page,
        )
        .then((data) => {
          const realData = data.body.body;
          this.answers.data = realData.qa_answer.map((answer) => {
            const newAnswer = Object.assign({}, answer);
            newAnswer.needShowMoreAnswer =
              newAnswer.answer.length > this.maxAnswerLetterCount;
            newAnswer.clickedShowMore = false;
            return newAnswer;
          });
          this.answers.totalCount = realData.total_count;
          this.fisrTimeLoadedAfterQuestionQuery =
            realData.qa_answer.length === 20;
          if (done) {
            done();
          }
        });
    },
  },
  mounted() {
    this.getParams();
    utils.bridgeInit();
    this.setUserLoginStatus();
    this.getQAData();

    // 给app判断页面是否加载成功
    document.body.insertAdjacentHTML(
      'beforeend',
      '<div id="loaded">loaded</div>',
    );
  },
  created() {
    document.title = '问题详情';
  },
};
</script>

<style lang="less">
.loading-layer {
  font-size: 12px !important;
}
.mint-msgbox-confirm {
  color: #ff5a60;
}
.mint-cell-wrapper {
  background: none;
}
.mint-msgbox {
  border-radius: 10px;
  width: 70%;
  .mint-msgbox-content {
    padding: 15px;
    border-bottom: 1px solid #e3e3e3;
    .mint-msgbox-message {
      color: #444;
    }
  }
  .mint-msgbox-btns {
    .mint-msgbox-cancel {
      color: #6f6f6f;
      border-right: 1px solid #e3e3e3;
    }
  }
}
#loaded {
  display: none;
}
.q-and-a-detail {
  .no-answer {
    .loading-layer {
      font-size: 12px;
      display: none;
    }
  }
}
</style>

<style lang="less" scoped>
.q-and-a-detail {
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  background-color: #f3f4f6;
  line-height: 1;
  &.padding-for-download {
    padding-bottom: 0.84rem;
  }
  .title-and-tag {
    background-color: #fff;
    padding: 0.15rem 0.15rem 0 0.15rem;
    .title {
      font-size: 0.18rem;
      font-weight: 600;
      line-height: 0.28rem;
      color: #444;
      white-space: pre-wrap;
      word-break: break-all;
    }
    .desc {
      color: #6f6f6f;
      margin-top: 0.1rem;
      font-size: 0;
      span.content {
        font-size: 0.14rem;
        line-height: 0.24rem;
        white-space: pre-wrap;
        word-break: break-all;
        &.margin-for-show-more {
          margin-right: 0.15rem;
        }
      }
      .show-all-content {
        color: #f98483;
        white-space: nowrap;
        font-size: 0.12rem;
        display: inline-flex;
        align-items: center;
        img {
          width: 0.08rem;
          height: 0.05rem;
          margin-left: 0.04rem;
        }
      }
    }
    .tags {
      padding-bottom: 0.1rem;
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.15rem;
      &.for-none-tag {
        padding-bottom: 0.15rem;
        margin-top: 0;
      }
      li {
        margin-bottom: 0.1rem;
        margin-right: 0.1rem;
        padding: 0.04rem 0.05rem;
        font-size: 0.12rem;
        border-radius: 3px;
        color: #aaa;
        background-color: #f3f4f6;
      }
    }
  }
  .national {
    background-color: #ffffff;
    padding: 0 0.1rem 0 0.15rem;
    display: flex;
    align-items: center;
    height: 0.4rem;
    position: relative;
    &::before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      width: 200%;
      height: 1px;
      background-color: #f0f0f0;
      transform-origin: left top;
      transform: scale(0.5);
    }
    .flag {
      border-radius: 3px;
      border: 1px solid #f0f0f0;
      width: 0.24rem;
      height: 0.16rem;
    }
    .title {
      margin-left: 0.09rem;
      font-size: 0.14rem;
      color: #6f6f6f;
      flex: 1;
    }
    .more {
      width: 0.14rem;
      height: 0.16rem;
    }
  }

  .answer-list {
    margin-top: 0.1rem;
    .answer-list-title {
      height: 0.35rem;
      background-color: #ffffff;
      font-size: 0.12rem;
      line-height: 0.28rem;
      color: #444;
      display: flex;
      align-items: center;
      padding-left: 0.15rem;
      font-weight: 600;
      position: relative;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 200%;
        height: 1px;
        background-color: #e9e9e9;
        transform-origin: left top;
        transform: scale(0.5);
      }
    }
    .answers {
      .answer {
        margin-top: 0.1rem;
        &:first-child {
          margin-top: 0;
        }
        background-color: #fff;
        .head {
          padding: 0.15rem 0.15rem 0.105rem 0.15rem;
          display: flex;
          align-items: center;
          .avartar {
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            border: 1px solid #f0f0f0;
          }
          .name {
            font-size: 0.15rem;
            font-weight: 600;
            color: #6f6f6f;
            margin-left: 0.09rem;
          }
          .official {
            margin-left: 0.05rem;
            width: 0.19rem;
            height: 0.19rem;
          }
          .fill-space {
            flex: 1;
          }
          .option {
            width: 0.15rem;
            height: 0.25rem;
            display: flex;
            align-items: center;
            img {
              width: 100%;
            }
          }
        }
        .content {
          padding: 0 0.15rem;
          color: #444;
          word-wrap: break-word;
          word-break: break-all;
          white-space: pre-wrap;
          font-size: 0;
          span.answer-text {
            font-size: 0.15rem;
            line-height: 0.24rem;
            &.margin-for-show-more {
              margin-right: 0.15rem;
            }
          }
          .show-all-content {
            color: #f98483;
            white-space: nowrap;
            font-size: 0.12rem;
            display: inline-flex;
            align-items: center;
            img {
              width: 0.08rem;
              height: 0.05rem;
              margin-left: 0.04rem;
            }
            &.clicked-show-more {
              img {
                transform: rotate(-180deg);
              }
            }
          }
        }
        .bottom {
          padding: 0.1rem 0.15rem 0.15rem 0.15rem;
          display: flex;
          align-items: center;
          .date {
            font-size: 0.12rem;
            color: #aaa;
          }
          .fill-space {
            flex: 1;
          }
          img {
            width: 0.2rem;
            height: 0.2rem;
          }
          .like-box {
            display: flex;
          }
          .liked-count {
            font-size: 0.14rem;
            line-height: 1;
            color: #aaa;
            margin-left: 0.05rem;
            margin-top: 0.05rem;
          }
        }
      }
    }
    .none-answer {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 0.3rem;
      padding-bottom: 0.6rem;
      background-color: #f3f4f6;
      img {
        width: 1.25rem;
        height: 1.25rem;
      }
      .desc {
        margin-top: 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        div {
          line-height: 1.1;
          margin-top: 0.1rem;
          &:first-child {
            margin-top: 0;
          }
          font-size: 0.14rem;
          color: #aaa;
        }
      }
    }
  }
  .bottom-0 {
    bottom: 0;
  }
  .bottom-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    padding: 0.05rem 0.1rem 0.05rem 0.35rem;
    justify-content: space-between;
    align-items: center;
    padding-bottom: calc(~'env(safe-area-inset-bottom) + 0.05rem');
    &.cant-share {
      padding-left: 0.1rem;
    }
    img {
      width: 0.2rem;
      height: 0.2rem;
    }
    .follow-box {
      margin-left: 0.65rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      div {
        font-size: 0.11rem;
        color: #6f6f6f;
        line-height: 1.1;
        margin-top: 0.08rem;
      }
    }
    .share {
      display: flex;
      flex-direction: column;
      align-items: center;
      div {
        font-size: 0.11rem;
        color: #6f6f6f;
        line-height: 1.1;
        margin-top: 0.08rem;
      }
    }
    .reply {
      margin-left: 0.65rem;
      flex-grow: 1;
      background-color: #ff5a60;
      border-radius: 0.03rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.18rem;
      color: #fff;
      height: 0.45rem;
    }
  }
  .on-errror {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.25rem;
    img {
      width: 2rem;
      height: 2rem;
    }
    .desc {
      font-size: 0.15rem;
      color: #aaa;
      margin-top: 0.1rem;
    }
  }
}
</style>
<style lang="less">
.report-pop-up {
  width: 100%;
  height: 50%;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .pop-title {
    height: 0.4rem;
    font-size: 0.15rem;
    color: #6f6f6f;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    .close {
      position: absolute;
      left: 0.1rem;
      top: 0.1rem;
      width: 0.2rem;
      height: 0.2rem;
      img {
        max-width: 100%;
      }
    }
  }
  .mint-checklist-title {
    margin: 0;
  }
  .pop-content {
    flex: 1;
    position: relative;
    display: flex;
    .reasons {
      padding: 0 0.1rem 0.2rem 0.1rem;
      display: flex;
      flex-wrap: wrap;
      .report-item {
        width: 50%;
        margin-top: 0.3rem;
        label {
          input[type='checkbox']:checked + span::after {
            display: block;
          }
          input {
            position: absolute;
            left: -1000px;
          }
          span {
            font-size: 0.15rem;
            color: #444;
            position: relative;
            padding-left: 0.26rem;
            &::before {
              content: '';
              background-image: url('../../static/img/check.png');
              background-repeat: no-repeat;
              background-position: center center;
              background-size: 0.16rem 0.16rem;
              position: absolute;
              width: 0.16rem;
              height: 0.16rem;
              left: 0;
              top: 0.02rem;
            }
            &::after {
              content: '';
              background-image: url('../../static/img/checked.png');
              background-repeat: no-repeat;
              background-position: center center;
              background-size: 0.16rem 0.16rem;
              position: absolute;
              width: 0.16rem;
              height: 0.16rem;
              left: 0;
              top: 0.02rem;
              display: none;
            }
          }
        }
      }
    }
  }
  .pop-foot {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .report {
      width: 100%;
      height: 0.45rem;
      background-color: #ff5a60;
      border-radius: 3px;
      color: #fff;
      font-size: 0.15rem;
      border-width: 0;
      border-radius: 0.03rem;
      outline: none;
      -webkit-appearance: none;
      &:disabled {
        opacity: 0.8;
      }
    }
  }
}
.wxa-share-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .tips {
    background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/pdvm/product-list/qa/add-qa/share-tips.png)
      no-repeat center / 100% 100%;
    width: 0.98rem;
    height: 0.5rem;
    position: absolute;
    right: 0.4rem;
    top: 0.1rem;
  }
}

.qa-detail-scroller {
  ._v-content {
    &::after {
      content: '';
      display: block;
      height: env(safe-area-inset-bottom);
    }
  }
}
</style>
